<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getPackages } from "../../../api/services/package.service";
import EditPackageModel from "./edit-package";

/**
 * Manage Package Page
 */
export default {
  page: {
    title: "Themen Verwalten",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    "edit-package-model": EditPackageModel,
  },
  data() {
    return {
      title: this.$i18n.t("packages.header.title"),
      items: [
        {
          text: this.$i18n.t("packages.header.item"),
          active: true,
        },
      ],
      showEditPackageModel: false,
      packages: null,
      packageToEdit: null,
    };
  },
  async mounted() {
    await this.getAllPackages();
  },
  methods: {
    async getAllPackages() {
      let getAllPackages = await getPackages();
      if (getAllPackages.length > 0) {
        this.packages = getAllPackages;
      }
    },
    clickEditPackage(packageId) {
      this.packageToEdit = packageId;
      this.showEditPackageModel = true;
    },
    realodPage() {
      window.location.reload();
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <!-- Simple Package Card -->
      <div
        class="col-lg-4 col-xl-4"
        v-for="(packageItem, packageIndex) in packages"
        :key="packageIndex"
      >
        <b-card style="height: 400px" no-body class="overflow-hidden">
          <b-row>
            <b-col md="12">
              <b-card-img
                v-if="packageItem.titleImage"
                :src="packageItem.titleImage"
                alt="Image"
                class="rounded-0"
                style="height: 240px"
              ></b-card-img>
              <b-card-img
                v-else
                :src="require('@/assets/images/Default Subpackage.jpg')"
                alt="Image"
                class="rounded-0"
                style="height: 240px"
              ></b-card-img>
            </b-col>
            <b-col md="12" class="p-4">
              <b-card-title>
                <h5 class="card-title text-limted-one-lines">
                  {{ packageItem.title }}
                </h5>
              </b-card-title>
              <b-card-text class="text-limted-two-lines">
                {{ packageItem.description }}
              </b-card-text>
              <b-button
                @click="clickEditPackage(packageItem.id)"
                variant="warning"
              >
                <i class="bx bxs-pencil mr-1"></i>
                {{ $t("general.buttons.edit") }}</b-button
              >
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
    <!-- end row -->

    <!-- Edit Subpackage Model -->
    <edit-package-model
      v-if="showEditPackageModel === true"
      :visible="showEditPackageModel"
      @close="showEditPackageModel = false"
      @reload="realodPage()"
      :packageID="packageToEdit"
    />
  </Layout>
</template>

<style scoped>
.text-limted-one-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.text-limted-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
